import React from 'react';
import styles from 'components/card/index.module.sass';

const Card = ({ children, onClick, className }) => {
  return (
    <div className={`${styles.card} ${className}`} onClick={onClick}>
      {children}
    </div>
  );
};

export default Card;
